import React from "react";
import styled from "@emotion/styled";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

const Score = ({ score }) => (
  <Container>
    <Label>คะแนนของฉัน</Label>
    <ScoreContainer>
      <ScoreNumber>{score !== undefined ? score : "-"}</ScoreNumber>
    </ScoreContainer>
  </Container>
);

const Container = styled.div`
  position: absolute;
  top: -106px;
  right: 0px;
  width: 130px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${responsive.tablet(css`
    width: 117px;
  `)}

  ${responsive.mobile(css`
    top: -82px;
    width: 100px;
  `)}
`;

const Label = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;

  text-align: center;
  letter-spacing: -0.02em;

  color: #4b5768;
  white-space: pre;

  ${responsive.tablet(css`
    font-size: 20px;
  `)}

  ${responsive.mobile(css`
    font-size: 16px;
    line-height: 26px;
  `)}
`;

const ScoreContainer = styled.div`
  margin-top: 2px;
  height: 64px;
  width: 100%;
  background: #16af7b;
  border-radius: 8px;

  display: flex;
  justify-content: center;
  align-items: center;

  ${responsive.tablet(css`
    height: 64px;
  `)}

  ${responsive.mobile(css`
    height: 46px;
  `)}
`;

const ScoreNumber = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 44px;
  line-height: 44px;

  text-align: center;

  color: #ffffff;

  ${responsive.tablet(css`
    font-size: 42px;
  `)}

  ${responsive.mobile(css`
    font-size: 24px;
    line-height: 26px;
  `)}
`;
export default Score;
